import { entityScripts } from "@/lib/entityJsonLd";
import { createFileRoute } from "@tanstack/react-router";
import PredictionLanding from "@/pages/PredictionLanding";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta, readable } from "@/lib/routeSocial";
import { findLanding, LANDING_ALIASES } from "@/lib/predictionLandings";

export const Route = createFileRoute("/predictions/$landing")({
  head: ({ params }) => {
    const slug = LANDING_ALIASES[params.landing] ?? params.landing;
    const landing = findLanding(slug);
    return {
      scripts: entityScripts({ type: "CollectionPage", name: (landing?.title ?? readable(slug)), path: `/predictions/${slug}`, crumbs: [{ name: "Predictions", path: "/predictions" }, { name: landing?.h1 ?? landing?.title ?? readable(slug), path: `/predictions/${slug}` }], extra: {} }),
      meta: socialMeta({
        seo: { topics: ["footballPredictions", "predictions"] },
        ...(landing?.keywords ? { keywords: landing.keywords } : {}),
        title: landing?.title ?? `${readable(slug)} | Statlign`,
        description:
          landing?.description ??
          "Football predictions with the model pick, odds, confidence and the reasoning behind every call.",
        ...(landing?.ogTitle ? { ogTitle: landing.ogTitle } : {}),
        ...(landing?.ogDescription ? { ogDescription: landing.ogDescription } : {}),
      }),
    };
  },
  component: () => (
    <MainLayout>
      <PredictionLanding />
    </MainLayout>
  ),
});
